export * from '../src/components/wui-loading-spinner/index.js';
//# sourceMappingURL=wui-loading-spinner.js.map